import { useState } from "react";

export function useModal<T>() {
    const [isVisible, setIsVisible] = useState(false);
    const [data, setData] = useState<T | null>(null);

    function openModal(data?: T) {
        if (data) {
            setData(data);
        } else {
            setData(null);
        }

        setIsVisible(true);
    }

    function closeModal() {
        setData(null);
        setIsVisible(false);
    }

    return {
        isVisible,
        data,
        openModal,
        closeModal,
    };
}
